const About = () => {
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-4xl font-bold mb-8 text-gray-900 text-center">
            About Me
          </h2>
          <div className="bg-white rounded-lg p-8 shadow-sm border border-gray-200">
            <p className="text-gray-700 mb-4 text-lg leading-relaxed">
              Hi! I'm a passionate developer who loves creating beautiful and functional
              web applications. With expertise in modern JavaScript frameworks and cloud
              technologies, I build solutions that make a difference.
            </p>
            <p className="text-gray-700 mb-6 text-lg leading-relaxed">
              When I'm not coding, you can find me exploring new technologies,
              contributing to open source, or sharing knowledge with the developer community.
            </p>
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <h3 className="font-bold text-gray-900 mb-3">Skills</h3>
                <ul className="text-gray-600 space-y-2">
                  <li>• JavaScript/TypeScript</li>
                  <li>• React/Vue.js</li>
                  <li>• Node.js</li>
                  <li>• Cloud Services</li>
                </ul>
              </div>
              <div>
                <h3 className="font-bold text-gray-900 mb-3">Interests</h3>
                <ul className="text-gray-600 space-y-2">
                  <li>• Web Development</li>
                  <li>• Cloud Architecture</li>
                  <li>• Open Source</li>
                  <li>• Developer Tools</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
